import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface AuthSliceState {
    accessToken?: string;
    segmentIds: string[];
    permissions: string[];
}

const initialState: AuthSliceState = {
    accessToken: undefined,
    segmentIds: [],
    permissions: [],
};

export const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAccessToken(
            state,
            action: PayloadAction<{
                accessToken: string;
                segmentIds: string[];
                permissions: string[];
            }>,
        ) {
            const { accessToken, segmentIds, permissions } = action.payload;
            return { ...state, accessToken, segmentIds, permissions };
        },
    },
});

export const { setAccessToken } = authSlice.actions;
